import { defineChain as viemDefineChain } from 'viem'

import type { AppChain } from './chain.types'

const viemArc = viemDefineChain({
  id: 5042,
  name: 'Arc',
  nativeCurrency: {
    name: 'USDC',
    symbol: 'USDC',
    decimals: 18
  },
  rpcUrls: {
    // Empty: no public Arc mainnet RPC published yet; cv2 reads via Alchemy/eRPC + the proxy.
    default: { http: [] }
  },
  blockExplorers: {
    default: { name: 'Arc Explorer', url: 'https://explorer.arc.io' }
  },
  contracts: {
    multicall3: { address: '0xcA11bde05977b3631167028862bE2a173976CA11', blockCreated: 0 }
  }
})

export const arc = {
  ...viemArc,
  custom: {
    name: 'Arc',
    shortName: 'Arc',
    morphoChainSlug: 'arc',
    hasFullSupport: true,
    blockExplorer: { baseUrl: 'https://explorer.arc.io', name: 'Arc Explorer' },
    contracts: {
      v1: {
        AdaptiveCurveIrm: {
          address: '0xF02615d094Fc02fC031C35fe705e175aA4653f20',
          startBlock: 1208685n
        },
        MorphoBlue: {
          address: '0x34CD04070dD72b14E241112F6d83812Df5Af7fCD',
          startBlock: 1208685n
        }
      },
      v2: {
        VaultV20Factory: {
          address: '0x3b0eefaBfa22ec7CF2c73877ac16e78D76749f12',
          startBlock: 1208931n
        },
        MorphoMarketV1AdapterV2Factory: {
          address: '0x6C2FF5114E45b50bc7195c2F1f87C98cbdad62Cc',
          startBlock: 1208978n
        },
        MorphoVaultV1AdapterFactory: {
          address: '0x77788033B22CEaB8D51Ec8F9dFD4a40E54F380B0',
          startBlock: 5314109n
        },
        RegistryList: {
          address: '0xdEBC92370Cd74d55DA144116138681dbbb528765',
          startBlock: 1208978n
        }
      }
    }
  }
} as const satisfies AppChain<{ v1: true; v2: true }>
